module.exports = __webpack_public_path__ + "img/12.2afb46b0.webp";